import React from 'react';
import {Row, Col, Button} from 'react-bootstrap';
// src
import PageHeader from '../PageHeader.js';
import PanelPrenotazione from './Panels/PanelPrenotazione.js';
import PanelProdotti from './Panels/PanelProdotti/PanelProdotti.js';
import PanelPagamento from './Panels/PanelPagamento.js';
import PanelIndirizzo from './Panels/PanelIndirizzo.js';
import PanelCliente from './Panels/PanelCliente/PanelCliente.js';
import ResponseBox from './Response/ResponseBox.js';
import {FORM_ID} from './formFields.js';
import {getSelValueEsteso} from './UtilOrder.js';
// css
import '../styles/sharedComponentsStyles.css';
import '../styles/commonStyles.css';
import './styles/ordersStyles.css';

const NewOrder = () => (
  <Col xs={12}>         
      <PageHeader title="Nuovo ordine" subTitle="Compila i dati del modulo" />             
      <NewOrderForm />           
  </Col>
);

// Gestisce la logica del form (post submit)
class NewOrderForm extends React.Component { 
  constructor() {    
    super();

    this.state={            
      needsTwoContacts: false,
      needsCalculation: true,
      saveBtnDisabled: false,
      editBtnDisabled: true,      
    };   

    this.handleSubmit = this.handleSubmit.bind(this);
    this.toggleNeedsTwoContacts = this.toggleNeedsTwoContacts.bind(this);
    this.toggleNeedsCalculation = this.toggleNeedsCalculation.bind(this);    
    this.editData = this.editData.bind(this);
    this.disableForm = this.disableForm.bind(this);
  }

  render() {  
    const { res, requestBody, invalid, displayErrors, needsTwoContacts, needsCalculation,
      saveBtnDisabled, editBtnDisabled } = this.state;     
    return (
      <Row className="noNegativeMargin addFooterMargin">   
      <Col xs={12}>
        <form className={displayErrors?'displayErrors' : ''} 
              onSubmit={this.handleSubmit} 
              id="order-form"
              noValidate>          
          <Row className="show-grid">
            <PanelPrenotazione />
          </Row>
          <Row className="show-grid">
            <PanelProdotti toggleNeedsCalculation={this.toggleNeedsCalculation} />
          </Row>
          <Row className="show-grid">
            <PanelPagamento 
              toggleNeedsTwoContacts={this.toggleNeedsTwoContacts} 
              toggleNeedsCalculation={this.toggleNeedsCalculation}
              needsCalculation={needsCalculation}
            />
          </Row>          
          <Row className="show-grid">
            <PanelCliente needsTwoContacts={needsTwoContacts} />
          </Row>
          <Row className="show-grid">
            <PanelIndirizzo />
          </Row>
          <Row className="show-grid">
            <Col xs={12} lg={4}>
              <Button type="submit" className="btn-primary" id="save-btn" 
                      disabled={saveBtnDisabled} block>SALVA</Button>          
            </Col>
            <Col xs={12} lg={4} className="mt-1 mt-lg-0">
              <Button className="btn-warning" onClick={this.editData} 
                      disabled={editBtnDisabled} block>MODIFICA</Button>          
            </Col>
          </Row>          
        </form>              
      </Col>

      <ResponseBox 
        invalid={invalid} res={res} 
        requestBody={requestBody} confirmSend={editBtnDisabled} 
        disableForm={this.disableForm} />  
      </Row> 
    );
  }

  // Segnala se è necessario invalidare il form 
  // se non sono stati inseriti due campi contatto
  toggleNeedsTwoContacts(isNeeded) {     
    this.setState({
      needsTwoContacts: isNeeded
    });         
  }

  // Segnala se è necessario invalidare il form 
  // se non sono stati calcolati i campi automatici
  toggleNeedsCalculation(isNeeded) {
    this.setState({
      needsCalculation: isNeeded
    });
  }

  // Validazione ed eventuale spedizione del form 
  handleSubmit(event) {    
    event.preventDefault();      
    const form = event.target;    

    // Invalida il form se non ha superato la validazione    
    if(!form.checkValidity() || this.state.needsCalculation) {
      this.setState({ 
        invalid: true, 
        displayErrors: true        
      });
      return;
    }    
    
    // Salva il form in quanto valido, permette l'invio
    let data = new FormData(form);    
    let jsxContent = {}; 
    let requestBody = {};

    // Ciclando con data.keys, 
    // <Typeahead/> e Buttons non vengono considerati
    for (let i=0; i < form.length; i++) {         
      form[i].disabled = true;          
    }

    for (let name of data.keys()) {      
      const input = form.elements[name];   

      if(input instanceof RadioNodeList) {
        input = [...input].find(i => i.checked);
      }                

      let parserName; // Tipo di conversione che il campo necessita
      let fieldTitle; // Nome del campo da visualizzare nel riepilogo
       
      let value;

      try {
        // La proprietà dataset permette di accedere agli attributi data-* 
        // (data-parse => tipo di conversione, data-caption => nome per il riepilogo)
        parserName = input.dataset.parse; 
        value = data.get(name); 
        
        let selVal = "";

        if (parserName === 'date' || parserName === 'number') {          
          value = (value==='')? '' : inputParsers[parserName](value);
        } else if (parserName === 'select') {  
          // Modalita' caparra deve venire stampata estesa, non come char  
          selVal = getSelValueEsteso(value);   
          // caparraTrattenuta da stringBool a "stringa"
          value = (selVal === "Sì")? "true" :((selVal === "No")? "false" : value);         
        } else if (parserName === 'select-label') {
          selVal = input.options[input.selectedIndex].innerHTML;
        } else if (parserName === 'bool') {
          selVal = selVal === "true" ? "Si" : "No";
        } else if ((parserName === 'dimArt') || (parserName === 'subGruppo')) {
          // dimArt, subGruppo non deve essere inviato
          continue;
        }    

        // separatori di sezione [%%%]
        let separator = input.dataset.separator;
        if(separator !== undefined) {
          jsxContent[separator] = separator;
        }

        fieldTitle = input.dataset.caption; 

        // jsxContent contiene i dati stampati a video,
        // i valori delle select vanno mostati estesi      
        jsxContent[fieldTitle] = (selVal === ""? value : selVal);                  
        
        requestBody[name] = value;
      } catch(err) {
        // Evita undefined error in caso di campi senza proprietà dataset           
        continue; 
      }        
      
    }    

    // Aggiunge il token di autenticazione e il nome della richiesta
    requestBody['serialeOperatore'] = localStorage.getItem('serialeOperatore');
    requestBody['request'] = 'insertNewOrder';  

    this.setState({
      res: jsxContent,
      requestBody: requestBody,
      invalid: false,
      displayErrors: false,
      saveBtnDisabled: true,
      editBtnDisabled: false,    
    });
  } 

  editData() {	    	
		let form = document.getElementById(FORM_ID);
		// riabilita i campi
		for (let i=0; i < form.length; i++) {         
      form[i].disabled = false;          
		}
    // riabilita salva e disabilita modifica
    this.setState({
      saveBtnDisabled: false,
      editBtnDisabled: true,       
    });  
  }

  // Passato come props a ResponseBox al fine di disabilitare 
  // i campi del form, btn Salva e btn Modifica post invio dell'ordine
  disableForm() {
    let form = document.getElementById(FORM_ID);
    for (let i=0; i < form.length; i++) {         
      form[i].disabled = true;          
    }

    this.setState({
      saveBtnDisabled: true,
      editBtnDisabled: true,       
    }); 
  }

}

// Converte date e numeri nel formato del database
const inputParsers = {
  // DD-MM-YYYY -> YYYY-MM-DD
  date(input) {
    const split = input.split('/');
    const day = split[0]
    const month = split[1];
    const year = split[2];
    return `${year}-${month}-${day}`;
  },
  // YYYY-MM-DD
  reverseDate(input) {
    const split = input.split('-');
    const day = split[2]
    const month = split[1];
    const year = split[0];
    return `${day}/${month}/${year}`;
  },
  // Int -> Double
  number(input) {
    return parseFloat(input);
  }
}

export { NewOrderForm };
export default NewOrder;


// WEBPACK FOOTER //
// ./src/cmp/Orders/NewOrder.js